/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable no-console */
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { esCotizable, generaComision } from "../../constants/estadosEdificio";
import { EDIFICIOS_EXCLUIDOS } from "../../constants/permisos";
import { useAuthContext } from "../../context/auth";
import { getEdificios } from "../../utils";
import "./stylesCotizadorProgrammaticInventario.scss";

export const CotizadorProgrammaticInventario = ({
  onSubmit,
  isProgrammaticSelected,
  resetInventario,
  onResetComplete,
  includeInstallingBuildings,
  defaultEdificios,
  defaultEdificiosAscensores,
  defaultEdificiosTotems,
  defaultEdificiosEspera,
  defaultEdificiosCowork,
}) => {
  // --- Estado primario: lista de edificios cargados ---
  const [edificios, setEdificios] = useState([]);

  // --- Estado primario: los 4 Sets de IDs (ÚNICA fuente de verdad para selección) ---
  const [edificiosSeleccionadosAscensores, setEdificiosSeleccionadosAscensores] = useState(
    new Set(defaultEdificiosAscensores ? defaultEdificiosAscensores.map(String) : [])
  );
  const [edificiosSeleccionadosTotems, setEdificiosSeleccionadosTotems] = useState(
    new Set(defaultEdificiosTotems ? defaultEdificiosTotems.map(String) : [])
  );
  const [edificiosSeleccionadosEspera, setEdificiosSeleccionadosEspera] = useState(
    new Set(defaultEdificiosEspera ? defaultEdificiosEspera.map(String) : [])
  );
  const [edificiosSeleccionadosCowork, setEdificiosSeleccionadosCowork] = useState(
    new Set(defaultEdificiosCowork ? defaultEdificiosCowork.map(String) : [])
  );

  // --- Estado UI: panel abierto y controles de circuito ---
  const [panelOpen, setPanelOpen] = useState(
    defaultEdificiosAscensores?.length > 0 ||
      defaultEdificiosTotems?.length > 0 ||
      defaultEdificiosEspera?.length > 0 ||
      defaultEdificiosCowork?.length > 0
  );
  const [selectAllAscensores, setSelectAllAscensores] = useState(false);
  const [selectAllTotems, setSelectAllTotems] = useState(false);
  const [selectAllCowork, setSelectAllCowork] = useState(false);
  const [selectAllEspera, setSelectAllEspera] = useState(false);

  // --- Estado derivado de edificios: ubicaciones y pantallas por ubicación ---
  const [ubicaciones, setUbicaciones] = useState([]);
  const [pantallasPorUbicacionMap, setPantallasPorUbicacionMap] = useState({});

  // --- Refs ---
  const hasInitializedRef = useRef(false);
  const isInitialSyncRef = useRef(true);

  const { pais, rol } = useAuthContext();

  // Helper único de completitud: un edificio está "completo" si, por cada circuito con
  // valor >0, su id está en el Set correspondiente. Criterio compartido por isFullMode,
  // el "SELECCIONAR TODOS" de EDIFICIOS y ubicacionesCompletas. Lee los 4 Sets del closure;
  // los memos que lo usan siguen listando los Sets en sus deps, así que la reactividad se
  // mantiene (recalculan al cambiar la selección y llaman al helper con los Sets frescos).
  const edificioCompleto = (e) => {
    const id = String(e.id);
    if (e.pantallas > 0 && !edificiosSeleccionadosAscensores.has(id)) return false;
    if (e.totems > 0 && !edificiosSeleccionadosTotems.has(id)) return false;
    if (e.cowork > 0 && !edificiosSeleccionadosCowork.has(id)) return false;
    if (e.espera > 0 && !edificiosSeleccionadosEspera.has(id)) return false;
    return true;
  };

  // ===========================================
  // MODOS DERIVADOS — se calculan automáticamente desde los Sets + edificios
  // ===========================================
  const isFullMode = useMemo(() => {
    if (edificios.length === 0) return false;
    return edificios.every(edificioCompleto);
  }, [
    edificios,
    edificiosSeleccionadosAscensores,
    edificiosSeleccionadosTotems,
    edificiosSeleccionadosCowork,
    edificiosSeleccionadosEspera,
  ]);

  // Comuna completa (DERIVADA): una ubicación está "completa" cuando TODOS sus edificios
  // están completos en cada circuito que tienen (mismo criterio, edificio por edificio,
  // que isFullMode). Corre sobre `edificios` ya filtrado (excluidos/no-cotizables no cuentan).
  // Una comuna sin edificios NO está completa.
  const ubicacionesCompletas = useMemo(() => {
    const completas = new Set();
    if (edificios.length === 0) return completas;
    const porUbicacion = {};
    edificios.forEach((e) => {
      (porUbicacion[e.ubicacion] = porUbicacion[e.ubicacion] || []).push(e);
    });
    Object.entries(porUbicacion).forEach(([ubicacion, edifs]) => {
      if (edifs.length === 0) return;
      if (edifs.every(edificioCompleto)) completas.add(ubicacion);
    });
    return completas;
  }, [
    edificios,
    edificiosSeleccionadosAscensores,
    edificiosSeleccionadosTotems,
    edificiosSeleccionadosCowork,
    edificiosSeleccionadosEspera,
  ]);

  const isLightMode = useMemo(() => {
    if (edificios.length === 0 || isFullMode) return false;
    // Todos los edificios deben estar seleccionados (en al menos un circuito)
    const selectedIds = new Set([
      ...edificiosSeleccionadosAscensores,
      ...edificiosSeleccionadosTotems,
      ...edificiosSeleccionadosCowork,
      ...edificiosSeleccionadosEspera,
    ]);
    const allSelected = edificios.every((e) => selectedIds.has(String(e.id)));
    if (!allSelected) return false;

    // Cada edificio en exactamente 1 circuito, siguiendo prioridad
    return edificios.every((e) => {
      const id = String(e.id);
      const count =
        (edificiosSeleccionadosAscensores.has(id) ? 1 : 0) +
        (edificiosSeleccionadosTotems.has(id) ? 1 : 0) +
        (edificiosSeleccionadosEspera.has(id) ? 1 : 0) +
        (edificiosSeleccionadosCowork.has(id) ? 1 : 0);
      if (count !== 1) return false;
      // Debe estar en el circuito de mayor prioridad disponible
      if (e.pantallas > 0) return edificiosSeleccionadosAscensores.has(id);
      if (e.totems > 0) return edificiosSeleccionadosTotems.has(id);
      if (e.espera > 0) return edificiosSeleccionadosEspera.has(id);
      if (e.cowork > 0) return edificiosSeleccionadosCowork.has(id);
      return false;
    });
  }, [
    edificios,
    isFullMode,
    edificiosSeleccionadosAscensores,
    edificiosSeleccionadosTotems,
    edificiosSeleccionadosCowork,
    edificiosSeleccionadosEspera,
  ]);

  // ===========================================
  // VALORES DERIVADOS (useMemo) — calculados automáticamente desde los Sets + edificios
  // ===========================================
  const derivedCounts = useMemo(() => {
    if (edificios.length === 0) {
      return {
        ascensoresSeleccionados: 0,
        totemsSeleccionados: 0,
        coworkSeleccionados: 0,
        esperaSeleccionados: 0,
        audienciaSeleccionadaAscensor: 0,
        audienciaSeleccionadaTotems: 0,
        audienciaSeleccionadaCowork: 0,
        audienciaSeleccionadaEspera: 0,
        audienciaSeleccionadaTotal: 0,
      };
    }

    // Helper: contar pantallas de un tipo para los edificios en un Set
    const countFor = (set, field) =>
      [...set].reduce((total, id) => {
        const edificio = edificios.find((e) => String(e.id) === id);
        return edificio ? total + (edificio[field] || 0) : total;
      }, 0);

    // Helper: contar audiencia para edificios en un Set que tienen cierto tipo de pantalla
    const audienceFor = (set, field) =>
      [...set].reduce((total, id) => {
        const edificio = edificios.find((e) => String(e.id) === id);
        return edificio && (edificio[field] || 0) > 0 ? total + (edificio.personas || 0) : total;
      }, 0);

    // Audiencia total: IDs únicos de edificios a través de todos los circuitos
    const uniqueEdificioIds = new Set([
      ...edificiosSeleccionadosAscensores,
      ...edificiosSeleccionadosTotems,
      ...edificiosSeleccionadosCowork,
      ...edificiosSeleccionadosEspera,
    ]);
    const audienciaSeleccionadaTotal = [...uniqueEdificioIds].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === id);
      return edificio ? total + (edificio.personas || 0) : total;
    }, 0);

    return {
      ascensoresSeleccionados: countFor(edificiosSeleccionadosAscensores, "pantallas"),
      totemsSeleccionados: countFor(edificiosSeleccionadosTotems, "totems"),
      coworkSeleccionados: countFor(edificiosSeleccionadosCowork, "cowork"),
      esperaSeleccionados: countFor(edificiosSeleccionadosEspera, "espera"),
      audienciaSeleccionadaAscensor: audienceFor(edificiosSeleccionadosAscensores, "pantallas"),
      audienciaSeleccionadaTotems: audienceFor(edificiosSeleccionadosTotems, "totems"),
      audienciaSeleccionadaCowork: audienceFor(edificiosSeleccionadosCowork, "cowork"),
      audienciaSeleccionadaEspera: audienceFor(edificiosSeleccionadosEspera, "espera"),
      audienciaSeleccionadaTotal,
    };
  }, [
    edificios,
    edificiosSeleccionadosAscensores,
    edificiosSeleccionadosTotems,
    edificiosSeleccionadosCowork,
    edificiosSeleccionadosEspera,
  ]);

  // ===========================================
  // HELPERS
  // ===========================================
  const updateSet = (setter, id, add, hasCircuit) => {
    if (!hasCircuit) return;
    setter((prev) => {
      const next = new Set(prev);
      if (add) {
        next.add(id);
      } else {
        next.delete(id);
      }
      return next;
    });
  };

  function sumarPantallas(edifs) {
    return edifs.reduce((total, edificio) => total + (edificio.pantallas || 0), 0);
  }

  function sumarTotems(edifs) {
    return edifs.reduce((total, edificio) => total + (edificio.totems || 0), 0);
  }

  function sumarCowork(edifs) {
    return edifs.reduce((total, edificio) => total + (edificio.cowork || 0), 0);
  }

  function sumarEspera(edifs) {
    return edifs.reduce((total, edificio) => total + (edificio.espera || 0), 0);
  }

  // Suma solo pantallas de los circuitos donde el edificio está efectivamente seleccionado
  function sumarPantallasSeleccionadas(edificio) {
    const id = String(edificio.id);
    let total = 0;
    if (edificiosSeleccionadosAscensores.has(id)) total += edificio.pantallas || 0;
    if (edificiosSeleccionadosTotems.has(id)) total += edificio.totems || 0;
    if (edificiosSeleccionadosCowork.has(id)) total += edificio.cowork || 0;
    if (edificiosSeleccionadosEspera.has(id)) total += edificio.espera || 0;
    return total;
  }

  // Función centralizada para cargar edificios con filtros
  const loadEdificios = useCallback(async () => {
    let newEdificios = await getEdificios({ pais });
    newEdificios = newEdificios.filter((edificio) => !edificio.eliminada && !EDIFICIOS_EXCLUIDOS.includes(edificio.id));
    newEdificios = newEdificios.filter((e) =>
      includeInstallingBuildings ? esCotizable(e.estado) : generaComision(e.estado)
    );
    newEdificios = newEdificios.filter(
      (e) => (e.pantallas || 0) + (e.totems || 0) + (e.espera || 0) + (e.cowork || 0) > 0
    );
    if (isProgrammaticSelected) {
      newEdificios = newEdificios.filter((edificio) => edificio.is_programmatic === true);
    }
    newEdificios.sort((a, b) => (a.edificio || "").localeCompare(b.edificio || ""));
    return newEdificios;
  }, [pais, includeInstallingBuildings, isProgrammaticSelected]);

  // Función para calcular ubicaciones y pantallas por ubicación
  const computeUbicaciones = (edifs) => {
    const uniqueUbicaciones = [...new Set(edifs.map((edificio) => edificio.ubicacion))];
    const pantallasMap = {};
    uniqueUbicaciones.forEach((ubicacion) => {
      pantallasMap[ubicacion] = edifs.reduce(
        (suma, edificio) =>
          edificio.ubicacion === ubicacion
            ? suma +
              (edificio.pantallas || 0) +
              (edificio.totems || 0) +
              (edificio.cowork || 0) +
              (edificio.espera || 0)
            : suma,
        0
      );
    });
    return { uniqueUbicaciones, pantallasMap };
  };

  // Helper: aplicar preset Full (todos los circuitos de todos los edificios)
  const applyFullPreset = () => {
    setEdificiosSeleccionadosAscensores(new Set(edificios.filter((e) => e.pantallas > 0).map((e) => String(e.id))));
    setEdificiosSeleccionadosTotems(new Set(edificios.filter((e) => e.totems > 0).map((e) => String(e.id))));
    setEdificiosSeleccionadosCowork(new Set(edificios.filter((e) => e.cowork > 0).map((e) => String(e.id))));
    setEdificiosSeleccionadosEspera(new Set(edificios.filter((e) => e.espera > 0).map((e) => String(e.id))));
  };

  // Helper: aplicar preset Light (1 circuito por edificio, por prioridad)
  const applyLightPreset = () => {
    const ascensoresSet = new Set();
    const totemsSet = new Set();
    const esperaSet = new Set();
    const coworkSet = new Set();

    edificios.forEach((e) => {
      const idStr = String(e.id);
      if (e.pantallas > 0) {
        ascensoresSet.add(idStr);
      } else if (e.totems > 0) {
        totemsSet.add(idStr);
      } else if (e.espera > 0) {
        esperaSet.add(idStr);
      } else if (e.cowork > 0) {
        coworkSet.add(idStr);
      }
    });

    setEdificiosSeleccionadosAscensores(ascensoresSet);
    setEdificiosSeleccionadosTotems(totemsSet);
    setEdificiosSeleccionadosEspera(esperaSet);
    setEdificiosSeleccionadosCowork(coworkSet);
  };

  // Helper: limpiar toda la selección
  const clearAll = () => {
    setEdificiosSeleccionadosAscensores(new Set());
    setEdificiosSeleccionadosTotems(new Set());
    setEdificiosSeleccionadosCowork(new Set());
    setEdificiosSeleccionadosEspera(new Set());
    setSelectAllAscensores(false);
    setSelectAllTotems(false);
    setSelectAllCowork(false);
    setSelectAllEspera(false);
  };

  // ===========================================
  // SINCRONIZACIÓN AL PADRE (único useEffect para onSubmit)
  // ===========================================
  useEffect(() => {
    if (isInitialSyncRef.current) return;

    onSubmit({
      ...derivedCounts,
      edificiosSeleccionadosAscensores: [...edificiosSeleccionadosAscensores],
      edificiosSeleccionadosTotems: [...edificiosSeleccionadosTotems],
      edificiosSeleccionadosCowork: [...edificiosSeleccionadosCowork],
      edificiosSeleccionadosEspera: [...edificiosSeleccionadosEspera],
    });
  }, [derivedCounts]);

  // ===========================================
  // INICIALIZACIÓN
  // ===========================================
  useEffect(() => {
    if (hasInitializedRef.current) return;
    const initialize = async () => {
      const newEdificios = await loadEdificios();
      const { uniqueUbicaciones, pantallasMap } = computeUbicaciones(newEdificios);

      const hasDefaults =
        (defaultEdificiosAscensores?.length || 0) > 0 ||
        (defaultEdificiosTotems?.length || 0) > 0 ||
        (defaultEdificiosEspera?.length || 0) > 0 ||
        (defaultEdificiosCowork?.length || 0) > 0;

      // Establecer estados
      setUbicaciones(uniqueUbicaciones);
      setPantallasPorUbicacionMap(pantallasMap);
      setEdificios(newEdificios);
      // El panel se abre si hay defaults (los modos Full/Light se derivan automáticamente)
      setPanelOpen(hasDefaults);

      if (hasDefaults) {
        // Calcular conteos iniciales directamente
        const countForInit = (ids, edifs, field) =>
          (ids || []).reduce((total, id) => {
            const edificio = edifs.find((e) => String(e.id) === String(id));
            return edificio ? total + (edificio[field] || 0) : total;
          }, 0);
        const audienceForInit = (ids, edifs, field) =>
          (ids || []).reduce((total, id) => {
            const edificio = edifs.find((e) => String(e.id) === String(id));
            return edificio && (edificio[field] || 0) > 0 ? total + (edificio.personas || 0) : total;
          }, 0);
        const uniqueIds = new Set(
          [
            ...(defaultEdificiosAscensores || []),
            ...(defaultEdificiosTotems || []),
            ...(defaultEdificiosEspera || []),
            ...(defaultEdificiosCowork || []),
          ].map(String)
        );
        const totalAudiencia = [...uniqueIds].reduce((total, id) => {
          const edificio = newEdificios.find((e) => String(e.id) === String(id));
          return edificio ? total + (edificio.personas || 0) : total;
        }, 0);

        onSubmit({
          ascensoresSeleccionados: countForInit(defaultEdificiosAscensores, newEdificios, "pantallas"),
          totemsSeleccionados: countForInit(defaultEdificiosTotems, newEdificios, "totems"),
          coworkSeleccionados: countForInit(defaultEdificiosCowork, newEdificios, "cowork"),
          esperaSeleccionados: countForInit(defaultEdificiosEspera, newEdificios, "espera"),
          audienciaSeleccionadaAscensor: audienceForInit(defaultEdificiosAscensores, newEdificios, "pantallas"),
          audienciaSeleccionadaTotems: audienceForInit(defaultEdificiosTotems, newEdificios, "totems"),
          audienciaSeleccionadaCowork: audienceForInit(defaultEdificiosCowork, newEdificios, "cowork"),
          audienciaSeleccionadaEspera: audienceForInit(defaultEdificiosEspera, newEdificios, "espera"),
          audienciaSeleccionadaTotal: totalAudiencia,
          edificiosSeleccionadosAscensores: [...(defaultEdificiosAscensores || [])],
          edificiosSeleccionadosTotems: [...(defaultEdificiosTotems || [])],
          edificiosSeleccionadosCowork: [...(defaultEdificiosCowork || [])],
          edificiosSeleccionadosEspera: [...(defaultEdificiosEspera || [])],
        });
      } else {
        onSubmit({
          ascensoresSeleccionados: 0,
          totemsSeleccionados: 0,
          coworkSeleccionados: 0,
          esperaSeleccionados: 0,
          audienciaSeleccionadaAscensor: 0,
          audienciaSeleccionadaTotems: 0,
          audienciaSeleccionadaCowork: 0,
          audienciaSeleccionadaEspera: 0,
          audienciaSeleccionadaTotal: 0,
          edificiosSeleccionadosAscensores: [],
          edificiosSeleccionadosTotems: [],
          edificiosSeleccionadosCowork: [],
          edificiosSeleccionadosEspera: [],
        });
      }

      hasInitializedRef.current = true;
      isInitialSyncRef.current = false;
    };
    initialize();
  }, [
    pais,
    rol,
    isProgrammaticSelected,
    includeInstallingBuildings,
    defaultEdificiosAscensores,
    defaultEdificiosTotems,
    defaultEdificiosEspera,
    defaultEdificiosCowork,
  ]);

  // ===========================================
  // RESET
  // ===========================================
  useEffect(() => {
    if (resetInventario) {
      isInitialSyncRef.current = true;
      const resetAndReload = async () => {
        try {
          const newEdificios = await loadEdificios();
          const { uniqueUbicaciones, pantallasMap } = computeUbicaciones(newEdificios);

          setEdificios(newEdificios);
          clearAll();
          setPanelOpen(false);
          setUbicaciones(uniqueUbicaciones);
          setPantallasPorUbicacionMap(pantallasMap);

          onSubmit({
            ascensoresSeleccionados: 0,
            totemsSeleccionados: 0,
            coworkSeleccionados: 0,
            esperaSeleccionados: 0,
            audienciaSeleccionadaAscensor: 0,
            audienciaSeleccionadaTotems: 0,
            audienciaSeleccionadaCowork: 0,
            audienciaSeleccionadaEspera: 0,
            audienciaSeleccionadaTotal: 0,
            edificiosSeleccionadosAscensores: [],
            edificiosSeleccionadosTotems: [],
            edificiosSeleccionadosCowork: [],
            edificiosSeleccionadosEspera: [],
          });
        } catch (error) {
          console.error("Error al resetear inventario:", error);
        } finally {
          isInitialSyncRef.current = false;
          onResetComplete();
        }
      };
      resetAndReload();
    }
  }, [resetInventario, pais, rol, isProgrammaticSelected, includeInstallingBuildings, onResetComplete, onSubmit]);

  // ===========================================
  // HANDLERS (solo actualizan Sets — los modos se derivan automáticamente)
  // ===========================================
  const handleCheckboxChange = (pantallas, isChecked, tipo, personas, id) => {
    const edificio = edificios.find((e) => String(e.id) === String(id));
    if (!edificio) return;

    const idAsString = String(id);

    if (tipo === "edificios") {
      updateSet(setEdificiosSeleccionadosAscensores, idAsString, isChecked, edificio.pantallas > 0);
      updateSet(setEdificiosSeleccionadosTotems, idAsString, isChecked, edificio.totems > 0);
      updateSet(setEdificiosSeleccionadosCowork, idAsString, isChecked, edificio.cowork > 0);
      updateSet(setEdificiosSeleccionadosEspera, idAsString, isChecked, edificio.espera > 0);
      if (!isChecked) {
        if (edificio.pantallas > 0) setSelectAllAscensores(false);
        if (edificio.totems > 0) setSelectAllTotems(false);
        if (edificio.cowork > 0) setSelectAllCowork(false);
        if (edificio.espera > 0) setSelectAllEspera(false);
      }
    } else if (tipo === "ascensores") {
      updateSet(setEdificiosSeleccionadosAscensores, idAsString, isChecked, edificio.pantallas > 0);
      if (!isChecked) setSelectAllAscensores(false);
    } else if (tipo === "totems") {
      updateSet(setEdificiosSeleccionadosTotems, idAsString, isChecked, edificio.totems > 0);
      if (!isChecked) setSelectAllTotems(false);
    } else if (tipo === "cowork") {
      updateSet(setEdificiosSeleccionadosCowork, idAsString, isChecked, edificio.cowork > 0);
      if (!isChecked) setSelectAllCowork(false);
    } else if (tipo === "espera") {
      updateSet(setEdificiosSeleccionadosEspera, idAsString, isChecked, edificio.espera > 0);
      if (!isChecked) setSelectAllEspera(false);
    }
  };

  const handleSelectAllChange = (isChecked, tipo, ubicacion = null) => {
    if (tipo === "network") {
      if (isChecked) {
        clearAll();
        applyFullPreset();
        setPanelOpen(true);
      } else {
        clearAll();
        setPanelOpen(false);
      }
    } else if (tipo === "networkLight") {
      if (isChecked) {
        clearAll();
        applyLightPreset();
        setPanelOpen(true);
      } else {
        clearAll();
        setPanelOpen(false);
      }
    } else if (tipo === "inventory") {
      if (isChecked) {
        clearAll();
        setPanelOpen(true);
      } else {
        clearAll();
        setPanelOpen(false);
      }
    } else if (tipo === "todosEdificios") {
      if (isChecked) {
        applyFullPreset();
        setSelectAllAscensores(true);
        setSelectAllTotems(true);
        setSelectAllCowork(true);
        setSelectAllEspera(true);
      } else {
        clearAll();
      }
    } else if (panelOpen) {
      if (tipo === "ubicacion" && ubicacion) {
        const edificiosDeUbicacion = edificios.filter((edificio) => edificio.ubicacion === ubicacion);
        if (isChecked) {
          edificiosDeUbicacion.forEach((edificio) => {
            const idAsString = String(edificio.id);
            updateSet(setEdificiosSeleccionadosAscensores, idAsString, true, edificio.pantallas > 0);
            updateSet(setEdificiosSeleccionadosTotems, idAsString, true, edificio.totems > 0);
            updateSet(setEdificiosSeleccionadosCowork, idAsString, true, edificio.cowork > 0);
            updateSet(setEdificiosSeleccionadosEspera, idAsString, true, edificio.espera > 0);
          });
        } else {
          edificiosDeUbicacion.forEach((edificio) => {
            const idAsString = String(edificio.id);
            updateSet(setEdificiosSeleccionadosAscensores, idAsString, false, edificio.pantallas > 0);
            updateSet(setEdificiosSeleccionadosTotems, idAsString, false, edificio.totems > 0);
            updateSet(setEdificiosSeleccionadosCowork, idAsString, false, edificio.cowork > 0);
            updateSet(setEdificiosSeleccionadosEspera, idAsString, false, edificio.espera > 0);
          });
        }
      } else if (tipo === "ascensores") {
        if (isChecked) {
          setEdificiosSeleccionadosAscensores(
            new Set(edificios.filter((e) => e.pantallas > 0).map((e) => String(e.id)))
          );
        } else {
          setEdificiosSeleccionadosAscensores(new Set());
        }
        setSelectAllAscensores(isChecked);
      } else if (tipo === "totems") {
        if (isChecked) {
          setEdificiosSeleccionadosTotems(new Set(edificios.filter((e) => e.totems > 0).map((e) => String(e.id))));
        } else {
          setEdificiosSeleccionadosTotems(new Set());
        }
        setSelectAllTotems(isChecked);
      } else if (tipo === "cowork") {
        if (isChecked) {
          setEdificiosSeleccionadosCowork(new Set(edificios.filter((e) => e.cowork > 0).map((e) => String(e.id))));
        } else {
          setEdificiosSeleccionadosCowork(new Set());
        }
        setSelectAllCowork(isChecked);
      } else if (tipo === "espera") {
        if (isChecked) {
          setEdificiosSeleccionadosEspera(new Set(edificios.filter((e) => e.espera > 0).map((e) => String(e.id))));
        } else {
          setEdificiosSeleccionadosEspera(new Set());
        }
        setSelectAllEspera(isChecked);
      }
    }
  };

  // ===========================================
  // RENDER
  // ===========================================

  // Checkbox "SELECCIONAR" se enciende cuando el panel está abierto y no es ni Full ni Light
  const isSelectMode = panelOpen && !isFullMode && !isLightMode;

  return (
    <div className="inventario">
      <p className="tituloinventario">INVENTARIO</p>
      <hr />

      <div className="seleccion">
        <input
          type="checkbox"
          className="cb123"
          checked={isFullMode && panelOpen}
          onChange={(e) => handleSelectAllChange(!isFullMode || !panelOpen, "network")}
          data-type="network"
        />
        <span>
          TODA LA RED FULL
          <span className="tooltip-icon">
            ?
            <span className="tooltip-bubble">
              Todos los edificios, todas las pantallas. Alcance total de la audiencia con la máxima potencia de nuestro
              canal.
            </span>
          </span>
        </span>
      </div>

      {pais === "Chile" && (
        <div className="seleccion">
          <input
            type="checkbox"
            className="cb123"
            checked={isLightMode && panelOpen}
            onChange={(e) => handleSelectAllChange(!isLightMode || !panelOpen, "networkLight")}
            data-type="networkLight"
          />
          <span>
            TODA LA RED LIGHT
            <span className="tooltip-icon">
              ?
              <span className="tooltip-bubble">
                Todos los edificios, un circuito por edificio con prioridad Ascensores. Máximo alcance, máxima
                eficiencia.
              </span>
            </span>
          </span>
        </div>
      )}

      <div className="seleccion">
        <input
          type="checkbox"
          className="cb123"
          checked={isSelectMode}
          onChange={(e) => handleSelectAllChange(!isSelectMode, "inventory")}
          data-type="inventory"
        />
        <span>SELECCIÓN</span>
      </div>
      <hr />

      {panelOpen && (
        <>
          <details>
            <summary className="subtitulo">EDIFICIOS</summary>
            <hr />
            {edificios.length > 0 && (
              <div>
                <div className="checkbox">
                  <input
                    type="checkbox"
                    style={{ width: "15px", height: "15px", marginRight: "10px" }}
                    checked={edificios.length > 0 && edificios.every(edificioCompleto)}
                    onChange={(e) => handleSelectAllChange(e.target.checked, "todosEdificios")}
                  />
                  <span style={{ fontWeight: "bold" }}>
                    {(() => {
                      const totalPantallasSeleccionadas = edificios.reduce(
                        (sum, e) => sum + sumarPantallasSeleccionadas(e),
                        0
                      );
                      return `${totalPantallasSeleccionadas} | SELECCIONAR TODOS`;
                    })()}
                  </span>
                </div>
                <hr />
                {(() => {
                  const renderEdificioItem = (edificio) => {
                    const tiposDisponibles = [
                      edificio.pantallas > 0 ? "ascensores" : null,
                      edificio.totems > 0 ? "totems" : null,
                      edificio.cowork > 0 ? "cowork" : null,
                      edificio.espera > 0 ? "espera" : null,
                    ].filter(Boolean);

                    const idStr = String(edificio.id);
                    const seleccionados = tiposDisponibles.filter((tipo) => {
                      if (tipo === "ascensores") return edificiosSeleccionadosAscensores.has(idStr);
                      if (tipo === "totems") return edificiosSeleccionadosTotems.has(idStr);
                      if (tipo === "cowork") return edificiosSeleccionadosCowork.has(idStr);
                      if (tipo === "espera") return edificiosSeleccionadosEspera.has(idStr);
                      return false;
                    });
                    const todosSeleccionados = seleccionados.length === tiposDisponibles.length;
                    const parcial = seleccionados.length > 0 && !todosSeleccionados;

                    return (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          className={parcial ? "checkbox-parcial" : ""}
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={todosSeleccionados}
                          onChange={(e) =>
                            handleCheckboxChange(0, e.target.checked, "edificios", edificio.personas, edificio.id)
                          }
                          value={edificio.id}
                          data-type="edificios"
                        />
                        <span>
                          {(edificio.pantallas || 0) +
                            (edificio.totems || 0) +
                            (edificio.cowork || 0) +
                            (edificio.espera || 0)}{" "}
                          | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    );
                  };

                  const operativos = edificios.filter((e) => e.estado === "OPERATIVO");
                  const noOperativos = edificios.filter(
                    (e) => e.estado === "INSTALACIÓN" || e.estado === "REACTIVACIÓN"
                  );

                  return (
                    <>
                      {operativos.map(renderEdificioItem)}
                      {noOperativos.length > 0 && (
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#aaa",
                            textAlign: "left",
                            padding: "0 0 11px",
                            letterSpacing: "1px",
                            marginLeft: "1rem",
                          }}
                        >
                          — EN INSTALACIÓN —
                        </div>
                      )}
                      {noOperativos.map(renderEdificioItem)}
                    </>
                  );
                })()}
              </div>
            )}
            {edificios.length === 0 && <p>Cargando edificios...</p>}
          </details>
          <hr />

          <details>
            <summary className="subtitulo">UBICACIÓN</summary>
            <hr />
            {ubicaciones.map((ubicacion, index) => (
              <div key={index} className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={ubicacionesCompletas.has(ubicacion)}
                  onChange={(e) => handleSelectAllChange(e.target.checked, "ubicacion", ubicacion)}
                  data-type="ubicacion"
                />
                <span>
                  {pantallasPorUbicacionMap[ubicacion] || 0} | {ubicacion.toUpperCase()}
                </span>
              </div>
            ))}
          </details>
          <hr />

          <details>
            <summary className="subtitulo">ASCENSORES</summary>
            <hr />
            <div className="checkbox">
              <input
                type="checkbox"
                style={{ width: "15px", height: "15px", marginRight: "10px" }}
                checked={selectAllAscensores}
                onChange={(e) => {
                  const newCheckedState = !selectAllAscensores;
                  setSelectAllAscensores(newCheckedState);
                  handleSelectAllChange(newCheckedState, "ascensores");
                }}
              />
              <span style={{ fontWeight: "bold" }}>{sumarPantallas(edificios)} | SELECCIONAR TODOS</span>
            </div>
            {!selectAllAscensores && edificios.length > 0 && (
              <div>
                {edificios
                  .filter((edificio) => edificio.pantallas > 0)
                  .map((edificio) => (
                    <div key={edificio.id} className="checkbox">
                      <input
                        type="checkbox"
                        style={{ width: "15px", height: "15px", marginRight: "10px" }}
                        checked={edificiosSeleccionadosAscensores.has(String(edificio.id)) || selectAllAscensores}
                        onChange={(e) =>
                          handleCheckboxChange(
                            edificio.pantallas,
                            e.target.checked,
                            "ascensores",
                            edificio.personas,
                            edificio.id
                          )
                        }
                        value={edificio.id}
                        data-type="ascensores"
                      />
                      <span>
                        {edificio.pantallas} | {edificio.edificio.toUpperCase()}
                      </span>
                    </div>
                  ))}
              </div>
            )}
            {edificios.length === 0 && !selectAllAscensores && <p>Cargando edificios...</p>}
          </details>
          <hr />

          {edificios.some((edificio) => edificio.totems > 0) && (
            <details>
              <summary className="subtitulo">CIRCULACIÓN</summary>
              <hr />
              <div className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={selectAllTotems}
                  onChange={(e) => {
                    const newCheckedState = !selectAllTotems;
                    setSelectAllTotems(newCheckedState);
                    handleSelectAllChange(newCheckedState, "totems");
                  }}
                  data-type="totems"
                />
                <span style={{ fontWeight: "bold" }}>{sumarTotems(edificios)} | SELECCIONAR TODOS</span>
              </div>
              {!selectAllTotems && edificios.length > 0 && (
                <div>
                  {edificios
                    .filter((edificio) => edificio.totems > 0)
                    .map((edificio) => (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={edificiosSeleccionadosTotems.has(String(edificio.id)) || selectAllTotems}
                          onChange={(e) =>
                            handleCheckboxChange(
                              edificio.totems,
                              e.target.checked,
                              "totems",
                              edificio.personas,
                              edificio.id
                            )
                          }
                          value={edificio.id}
                          data-type="totems"
                        />
                        <span>
                          {edificio.totems} | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    ))}
                </div>
              )}
              <hr />
            </details>
          )}
          <hr />

          {edificios.some((edificio) => edificio.espera > 0) && (
            <details>
              <summary className="subtitulo">ESPERA</summary>
              <hr />
              <div className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={selectAllEspera}
                  onChange={(e) => {
                    const newCheckedState = !selectAllEspera;
                    setSelectAllEspera(newCheckedState);
                    handleSelectAllChange(newCheckedState, "espera");
                  }}
                  data-type="espera"
                />
                <span style={{ fontWeight: "bold" }}>{sumarEspera(edificios)} | SELECCIONAR TODOS</span>
              </div>
              {!selectAllEspera && edificios.length > 0 && (
                <div>
                  {edificios
                    .filter((edificio) => edificio.espera > 0)
                    .map((edificio) => (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={edificiosSeleccionadosEspera.has(String(edificio.id)) || selectAllEspera}
                          onChange={(e) =>
                            handleCheckboxChange(
                              edificio.espera,
                              e.target.checked,
                              "espera",
                              edificio.personas,
                              edificio.id
                            )
                          }
                          value={edificio.id}
                          data-type="espera"
                        />
                        <span>
                          {edificio.espera} | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    ))}
                </div>
              )}
              <hr />
            </details>
          )}
          <hr />

          {edificios.some((edificio) => edificio.cowork > 0) && (
            <details>
              <summary className="subtitulo">COWORK iF</summary>
              <hr />
              <div className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={selectAllCowork}
                  onChange={(e) => {
                    const newCheckedState = !selectAllCowork;
                    setSelectAllCowork(newCheckedState);
                    handleSelectAllChange(newCheckedState, "cowork");
                  }}
                  data-type="cowork"
                />
                <span style={{ fontWeight: "bold" }}>{sumarCowork(edificios)} | SELECCIONAR TODOS</span>
              </div>
              {!selectAllCowork && edificios.length > 0 && (
                <div>
                  {edificios
                    .filter((edificio) => edificio.cowork > 0)
                    .map((edificio) => (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={edificiosSeleccionadosCowork.has(String(edificio.id)) || selectAllCowork}
                          onChange={(e) =>
                            handleCheckboxChange(
                              edificio.cowork,
                              e.target.checked,
                              "cowork",
                              edificio.personas,
                              edificio.id
                            )
                          }
                          value={edificio.id}
                          data-type="cowork"
                        />
                        <span>
                          {edificio.cowork} | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    ))}
                </div>
              )}
              <hr />
            </details>
          )}
          <hr />
        </>
      )}
    </div>
  );
};
